import { render, staticRenderFns } from "./MoondayList.vue?vue&type=template&id=97ed44c6&"
import script from "./MoondayList.vue?vue&type=script&lang=js&"
export * from "./MoondayList.vue?vue&type=script&lang=js&"
import style0 from "./MoondayList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ed44c6')) {
      api.createRecord('97ed44c6', component.options)
    } else {
      api.reload('97ed44c6', component.options)
    }
    module.hot.accept("./MoondayList.vue?vue&type=template&id=97ed44c6&", function () {
      api.rerender('97ed44c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/月亮日記/MoondayList.vue"
export default component.exports